"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSubscriptionPositions = exports.UpdateSubscriptionPositions = exports.UpdateSubscriptionPositionsActionTypes = exports.updateSubscriptionDefinitions = exports.UpdateSubscriptionDefinitions = exports.UpdateSubscriptionDefinitionsActionTypes = exports.UpdateSubscriptionDefinition = exports.updateSubscriptionDefinition = exports.deleteSubscriptionTranslation = exports.DeleteSubscriptionTranslation = exports.DeleteSubscriptionTranslationActionTypes = exports.CreateSubscriptionTranslation = exports.createSubscriptionTranslation = exports.CreateSubscriptionDefinition = exports.createSubscriptionDefinition = exports.FetchSubscriptionDefinitions = exports.loadSubscriptionDefinitions = exports.UpdateSubscriptionDefinitionActionTypes = exports.CreateSubscriptionTranslationActionTypes = exports.CreateSubscriptionDefinitionActionTypes = exports.FetchSubscriptionDefinitionsActionTypes = exports.SubscriptionDefinitionsActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var _actions2 = require("settings-ui-lib/utils/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _I18n = _interopRequireDefault(require("I18n"));

var SubscriptionDefinitionsActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_SUBSCRIPTION_DEFINITIONS: null,
  FETCH_SUBSCRIPTION_DEFINITIONS: null,
  CREATE_SUBSCRIPTION_DEFINITION: null,
  CREATE_SUBSCRIPTION_TRANSLATION: null,
  DELETE_SUBSCRIPTION_TRANSLATION: null,
  UPDATE_SUBSCRIPTION_DEFINITION: null,
  UPDATE_SUBSCRIPTION_DEFINITIONS: null,
  UPDATE_SUBSCRIPTION_POSITIONS: null
}, _constants.SUBSCRIPTION_DEFINTION);
exports.SubscriptionDefinitionsActionTypes = SubscriptionDefinitionsActionTypes;
var FetchSubscriptionDefinitionsActionTypes = (0, _actions.createRequestTypes)(SubscriptionDefinitionsActionTypes.FETCH_SUBSCRIPTION_DEFINITIONS);
exports.FetchSubscriptionDefinitionsActionTypes = FetchSubscriptionDefinitionsActionTypes;
var CreateSubscriptionDefinitionActionTypes = (0, _actions.createRequestTypes)(SubscriptionDefinitionsActionTypes.CREATE_SUBSCRIPTION_DEFINITION);
exports.CreateSubscriptionDefinitionActionTypes = CreateSubscriptionDefinitionActionTypes;
var CreateSubscriptionTranslationActionTypes = (0, _actions.createRequestTypes)(SubscriptionDefinitionsActionTypes.CREATE_SUBSCRIPTION_TRANSLATION);
exports.CreateSubscriptionTranslationActionTypes = CreateSubscriptionTranslationActionTypes;
var UpdateSubscriptionDefinitionActionTypes = (0, _actions.createRequestTypes)(SubscriptionDefinitionsActionTypes.UPDATE_SUBSCRIPTION_DEFINITION);
exports.UpdateSubscriptionDefinitionActionTypes = UpdateSubscriptionDefinitionActionTypes;
var loadSubscriptionDefinitions = (0, _fluxActions.createAction)(SubscriptionDefinitionsActionTypes.LOAD_SUBSCRIPTION_DEFINITIONS);
exports.loadSubscriptionDefinitions = loadSubscriptionDefinitions;
var FetchSubscriptionDefinitions = (0, _actions.createRequestActions)(FetchSubscriptionDefinitionsActionTypes);
exports.FetchSubscriptionDefinitions = FetchSubscriptionDefinitions;
var createSubscriptionDefinition = (0, _fluxActions.createAction)(SubscriptionDefinitionsActionTypes.CREATE_SUBSCRIPTION_DEFINITION, (0, _actions.mapPayloadTo)('data'));
exports.createSubscriptionDefinition = createSubscriptionDefinition;

function translateErrorEntity(error) {
  if (error.responseJSON && error.responseJSON.errorType) {
    var replacementMap = {};

    if (error.responseJSON.errorTokens) {
      for (var key in error.responseJSON.errorTokens) {
        if (error.responseJSON.errorTokens.hasOwnProperty(key)) {
          replacementMap[key] = error.responseJSON.errorTokens[key].join(', ');
        }
      }
    }

    return _I18n.default.text("marketing.email.subscriptions." + error.responseJSON.errorType, replacementMap);
  } else if (error.responseJSON.message) {
    return error.responseJSON.message;
  }

  return 'An unknown error has occurred.';
}

var CreateSubscriptionDefinition = (0, _actions.createRequestActions)(CreateSubscriptionDefinitionActionTypes, {
  failureMetaCreator: function failureMetaCreator(error) {
    return (0, _extends2.default)({}, (0, _actions2.createRequestStatusMeta)(CreateSubscriptionDefinitionActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions2.createDangerNotificationMeta)(translateErrorEntity(error)));
  }
});
exports.CreateSubscriptionDefinition = CreateSubscriptionDefinition;
var createSubscriptionTranslation = (0, _fluxActions.createAction)(SubscriptionDefinitionsActionTypes.CREATE_SUBSCRIPTION_TRANSLATION, (0, _actions.mapPayloadTo)('data'));
exports.createSubscriptionTranslation = createSubscriptionTranslation;
var CreateSubscriptionTranslation = (0, _actions.createRequestActions)(CreateSubscriptionTranslationActionTypes);
exports.CreateSubscriptionTranslation = CreateSubscriptionTranslation;
var DeleteSubscriptionTranslationActionTypes = (0, _actions.createRequestTypes)(SubscriptionDefinitionsActionTypes.DELETE_SUBSCRIPTION_TRANSLATION);
exports.DeleteSubscriptionTranslationActionTypes = DeleteSubscriptionTranslationActionTypes;
var DeleteSubscriptionTranslation = (0, _actions.createRequestActions)(DeleteSubscriptionTranslationActionTypes);
exports.DeleteSubscriptionTranslation = DeleteSubscriptionTranslation;
var deleteSubscriptionTranslation = (0, _fluxActions.createAction)(SubscriptionDefinitionsActionTypes.DELETE_SUBSCRIPTION_TRANSLATION, (0, _actions.mapPayloadTo)('data'));
exports.deleteSubscriptionTranslation = deleteSubscriptionTranslation;
var updateSubscriptionDefinition = (0, _fluxActions.createAction)(SubscriptionDefinitionsActionTypes.UPDATE_SUBSCRIPTION_DEFINITION, (0, _actions.mapPayloadTo)('data'));
exports.updateSubscriptionDefinition = updateSubscriptionDefinition;
var UpdateSubscriptionDefinition = (0, _actions.createRequestActions)(UpdateSubscriptionDefinitionActionTypes);
exports.UpdateSubscriptionDefinition = UpdateSubscriptionDefinition;
var UpdateSubscriptionDefinitionsActionTypes = (0, _actions.createRequestTypes)(SubscriptionDefinitionsActionTypes.UPDATE_SUBSCRIPTION_DEFINITIONS);
exports.UpdateSubscriptionDefinitionsActionTypes = UpdateSubscriptionDefinitionsActionTypes;
var UpdateSubscriptionDefinitions = (0, _actions.createRequestActions)(UpdateSubscriptionDefinitionsActionTypes);
exports.UpdateSubscriptionDefinitions = UpdateSubscriptionDefinitions;
var updateSubscriptionDefinitions = (0, _fluxActions.createAction)(SubscriptionDefinitionsActionTypes.UPDATE_SUBSCRIPTION_DEFINITIONS, (0, _actions.mapPayloadTo)('data'));
exports.updateSubscriptionDefinitions = updateSubscriptionDefinitions;
var UpdateSubscriptionPositionsActionTypes = (0, _actions.createRequestTypes)(SubscriptionDefinitionsActionTypes.UPDATE_SUBSCRIPTION_POSITIONS);
exports.UpdateSubscriptionPositionsActionTypes = UpdateSubscriptionPositionsActionTypes;
var UpdateSubscriptionPositions = (0, _actions.createRequestActions)(UpdateSubscriptionPositionsActionTypes);
exports.UpdateSubscriptionPositions = UpdateSubscriptionPositions;
var updateSubscriptionPositions = (0, _fluxActions.createAction)(SubscriptionDefinitionsActionTypes.UPDATE_SUBSCRIPTION_POSITIONS, (0, _actions.mapPayloadTo)('data'));
exports.updateSubscriptionPositions = updateSubscriptionPositions;